<template>
  <el-table class="common-el-table-styles" v-loading="loading" :data="data" :height="height" border stripe>
    <el-table-column
      v-for="(col, id) in columns"
      :key="id"
      :prop="col.key"
      :label="col.title"
      :show-overflow-tooltip="col.overflow"
      :min-width="col.width"
      :align="col.align"
    >
      <template slot-scope="scope">
        <div v-if="col.key === 'control'">
          <el-button type="text" size="small" @click="$emit('on-edit', scope.row)">编辑</el-button>
        </div>
        <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
        <span v-else-if="col.key === 'upTime'">{{ scope.row[col.key] | datetimeToSec }}</span>

        <span v-else>{{ scope.row[col.key] }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  name: 'ptomAgentInfoTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number,
      default() {
        return 330
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  position: relative;
  height: calc(100% - 32px);
  background-color: #fff;
  z-index: 9;

  .c-control-margin {
    margin: 0;
    padding: 0 6px;
  }
}
</style>
